import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import T from '../../Locale';
import { toggleModal } from '../../Actions';
import { valueEdit, valuesToggleForShare } from './Actions';
const ComponentListItemControls = ({ item, showImage, showDeleteModal, toggleForSharing, shareChecked = [], onEdit }) => {
    const image = (_jsx("button", Object.assign({ className: "control", onClick: () => showImage(item.id) }, { children: _jsx("i", { className: "fa fa-camera", "aria-hidden": "true" }) })));
    let share = _jsx("div", {});
    // If the item does not have an owner set, it means the current user
    // is the owner, and should be able to share the item.
    if (!item.owner) {
        const isChecked = shareChecked.indexOf(item.id) > -1;
        const checkboxId = `checkbox_${item.id}`;
        share = (_jsxs("div", { children: [_jsx("input", { type: "checkbox", id: checkboxId, onChange: () => { toggleForSharing(item.id); }, checked: isChecked }), _jsx("label", Object.assign({ htmlFor: checkboxId }, { children: T.translate('values.shareMark') }))] }));
    }
    return (_jsxs("div", Object.assign({ className: "callout__controls" }, { children: [!item.image || image, !item.owner && (_jsx("button", Object.assign({ className: "control", onClick: onEdit }, { children: _jsx("i", { className: "fa fa-pencil", "aria-hidden": "true" }) }))), _jsx("button", Object.assign({ className: "control", onClick: () => { showDeleteModal(item); } }, { children: _jsx("i", { className: "fa fa-trash", "aria-hidden": "true" }) })), share] })));
};
ComponentListItemControls.propTypes = {
    item: PropTypes.object.isRequired,
    showImage: PropTypes.func.isRequired,
    showDeleteModal: PropTypes.func.isRequired,
    toggleForSharing: PropTypes.func.isRequired,
    shareChecked: PropTypes.array,
    onEdit: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({ shareChecked: state.values.itemsForShare || [] });
const mapDispatchToProps = (dispatch, ownProps) => ({
    showImage: (valueId) => {
        dispatch(toggleModal('value-image', valueId));
    },
    showDeleteModal: (item) => {
        const translationKey = item.owner ? 'values.remove' : 'values.delete';
        const content = T.translate(translationKey, { name: item.name });
        dispatch(toggleModal('delete-value', item.id, content));
    },
    toggleForSharing: (id) => {
        dispatch(valuesToggleForShare(id));
    },
    onEdit: () => {
        dispatch(valueEdit(ownProps.item));
        dispatch(toggleModal('create-value'));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(ComponentListItemControls);
